import { IJobRunDetail, JobStatus } from "@/api/admin/admin.types";
import { Alert } from "@/components/shared/alerts/Alert";
import { AlertTitle, Typography } from "@mui/material";

interface JobErrorBannerProps {
    job: IJobRunDetail;
}

export const JobErrorBanner = ({ job }: JobErrorBannerProps) => {
    if (job.status !== JobStatus.FAILED) {
        return null;
    }

    return (
        <Alert severity="error">
            <AlertTitle sx={{ fontWeight: 600 }}>Job Failed</AlertTitle>
            {job.error_message && (
                <Typography
                    sx={{
                        mt: 0.5,
                        fontFamily: "monospace",
                        fontSize: "0.75rem",
                    }}
                >
                    {job.error_message}
                </Typography>
            )}
        </Alert>
    );
};
